import Vue from 'vue'

export const successNotification = ({ message }) => {
  const { noty } = Vue.prototype.$_activitySummary_config

  return noty({
    type: 'success',
    timeout: 5000,
    text: message
  })()
}

export const errorNotification = ({ message }) => {
  const { noty } = Vue.prototype.$_activitySummary_config

  return noty({
    type: 'error',
    timeout: 10000,
    text: message
  })()
}

export const layoutsNotConfiguredNotification = () => {
  const { noty } = Vue.prototype.$_activitySummary_config

  return noty({
    type: 'error',
    timeout: 10000,
    text: 'Your activity layouts have not been configured yet. Please speak to your account manager to solve this.'
  })()
}



// WEBPACK FOOTER //
// ./~/vue-components/activity-summary/components/notifications.js